import { KlusModel } from "@personeel/models/KlusModel";

/** De twee mogelijke drag-richtingen voor een klus */
export type DragMode = "tijd" | "tussenDiensten";

/**
 * Bepaal de dragmode op basis van de dominante bewegingsrichting van de muis.
 * Horizontaal (tijd) heeft voorrang als de klus horizontaal versleepbaar is,
 * anders wordt altijd tussenDiensten gebruikt.
 *
 * @param dx - horizontale muisbeweging in pixels t.o.v. mousedown-positie
 * @param dy - verticale muisbeweging in pixels t.o.v. mousedown-positie
 * @param klus - de klus die versleept wordt
 * @returns de bepaalde dragmode, of null als de beweging nog te klein is
 */
// TO DO niet toegewezen klussen ook schuiven???
export function bepaalDragMode(dx: number, dy: number, klus: KlusModel): DragMode | null {
  // Wacht tot de muis minimaal 5px bewogen heeft voor richting-detectie
  if (Math.abs(dx) <= 5 && Math.abs(dy) <= 5) return null;

  // Horizontaal mag alleen als het klustype verschuifbaar is in tijd
  const magInTijd = ["SCHAFT", "TAXI"].includes(klus.klusSoort);

  if (magInTijd && Math.abs(dx) >= Math.abs(dy)) return "tijd";
  return "tussenDiensten";
}
